import { Modal } from '@onl-web/shared/components'

import { Backdrop, Card, ConfirmButton, ContentWrapper, Description, TextArea, Title } from './styles'

interface AlertModalProps {
  isOpen: boolean
  title: string
  description?: string
  confirmText?: string
  onConfirm: () => void
}

export default function AlertModal({ isOpen, title, description, confirmText = '확인', onConfirm }: AlertModalProps) {
  return (
    <Modal isOpen={isOpen} onClose={onConfirm}>
      <Backdrop />
      <ContentWrapper>
        <Card>
          <TextArea>
            <Title>{title}</Title>
            {description && <Description>{description}</Description>}
          </TextArea>
          <ConfirmButton type='button' onClick={onConfirm}>
            {confirmText}
          </ConfirmButton>
        </Card>
      </ContentWrapper>
    </Modal>
  )
}
